import React from 'react'
export const Project = (): React.ReactNode => (
  <svg width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#ProjectClip0)">
      <path
        d="M30 22a7.99 7.99 0 0 0-5.757 13.54 4.99 4.99 0 0 1 2.355-2.9 5 5 0 1 1 6.8 0 4.99 4.99 0 0 1 2.355 2.9A7.99 7.99 0 0 0 30 22z"
        className="SRC-icon-fill"
      />
      <path
        d="M30 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM26.008 36.922a7.93 7.93 0 0 0 7.984 0A3 3 0 0 0 31 34h-2a3 3 0 0 0-2.992 2.922zM50.62 8.805a2.973 2.973 0 0 1 .259-3.926A3 3 0 0 1 56 6.999a2.972 2.972 0 0 1-.619 1.8 4 4 0 0 1 1.273 1.584 5 5 0 1 0-7.308 0 4 4 0 0 1 1.273-1.578z"
        className="SRC-icon-fill"
      />
      <path
        d="M53 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM51.04 11.6a4.973 4.973 0 0 0 3.919 0 2 2 0 0 0-3.918 0zM53 54a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM53 56a2 2 0 0 0-1.96 1.6 4.978 4.978 0 0 0 3.914 0A1.994 1.994 0 0 0 53 56z"
        className="SRC-icon-fill"
      />
      <path
        d="M53 48a4.983 4.983 0 0 0-3.654 8.388 4 4 0 0 1 1.273-1.583 2.972 2.972 0 0 1 .26-3.926A3 3 0 0 1 55.998 53a2.967 2.967 0 0 1-.618 1.8c.554.409.993.955 1.273 1.584A4.982 4.982 0 0 0 53 48zM5.04 11.6a4.973 4.973 0 0 0 3.919 0 2 2 0 0 0-3.918 0zM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        className="SRC-icon-fill"
      />
      <path
        d="M4.619 8.805a2.972 2.972 0 0 1 .26-3.926A3 3 0 0 1 10 6.999a2.972 2.972 0 0 1-.619 1.8 4 4 0 0 1 1.273 1.584 5 5 0 1 0-7.308 0 4 4 0 0 1 1.273-1.578z"
        className="SRC-icon-fill"
      />
      <path
        d="M29.562 9.981a5 5 0 1 0 0 0zM28.072 2.7a2.976 2.976 0 0 1 2.196-.688 3 3 0 1 1-2.144 5.328 3 3 0 0 1-.051-4.64z"
        className="SRC-header-only-fill"
        fill="#DDDDDF"
      />
      <path
        d="M7 56a2 2 0 0 0-1.96 1.6 4.973 4.973 0 0 0 3.919 0 2 2 0 0 0-1.96-1.6zM7 54a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        className="SRC-icon-fill"
      />
      <path
        d="M7 48a4.983 4.983 0 0 0-3.654 8.388 4 4 0 0 1 1.273-1.583 2.972 2.972 0 0 1 .26-3.926A3 3 0 0 1 9.999 53a2.972 2.972 0 0 1-.618 1.8 4 4 0 0 1 1.273 1.583A4.981 4.981 0 0 0 7 48z"
        className="SRC-icon-fill"
      />
      <path
        d="M18 29h-2v2h2v-2zM14 29h-2v2h2v-2zM48 29h-2v2h2v-2zM44 29h-2v2h2v-2zM31 16h-2v2h2v-2zM31 12h-2v2h2v-2zM31 46h-2v2h2v-2zM31 42h-2v2h2v-2zM29.562 50.019a5 5 0 1 0 .876 9.96 5 5 0 1 0-.876-9.96zm3.426 4.718a3 3 0 1 1-5.978.527 3 3 0 0 1 5.978-.528zM10 30a5 5 0 1 0-5 5 5.006 5.006 0 0 0 5-5zm-8 0a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM55 25a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5zm0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM40.7 22.787a16.249 16.249 0 0 0 9.258-10.512l-1.922-.55a14.263 14.263 0 0 1-8.124 9.224l-.309.132.788 1.838.309-.132zM49.961 47.725A16.248 16.248 0 0 0 40.7 37.213l-.309-.132-.788 1.838.309.132a14.261 14.261 0 0 1 8.124 9.224l1.925-.55zM11.961 11.725l-1.922.55A16.248 16.248 0 0 0 19.3 22.787l.31.132.787-1.838-.309-.132a14.263 14.263 0 0 1-8.127-9.224zM19.3 37.213a16.247 16.247 0 0 0-9.258 10.512l1.922.55a14.264 14.264 0 0 1 8.124-9.224l.309-.132-.788-1.838-.31.132z"
        fill="#DDDDDF"
        className="SRC-header-only-fill"
      />
    </g>
    <defs>
      <clipPath id="ProjectClip0">
        <path fill="#fff" d="M0 0h60v60H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default Project
